/* global globalThis */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Ajax } from '../../../components/Ajax';
import { PopupTypes } from '../../../components/Popup';
import { T } from '../../../components/Translations';
import { ApiUrl, AppPages, Defines, UserRoles } from '../../../project/Defines';
import { Project } from '../../../project/Project';
import { EVENT_NAME } from '../../../project/utilities';
import DetailView from '../../../Shared/DetailView';
import InputCont from '../../../Shared/Form/InputCont';
import { hideLoader, showLoader } from '../../../Shared/Loader';
import useDetail from '../../../Shared/useDetail';
import { closeAllPopups, openPopup } from '../../../store/actions';
import Attachments from '../Attachment';

import moment from 'moment';

const listUpdateEvent = EVENT_NAME.SERVICE_CALL_LIST_UPDATE;
/**
 * @exports ServiceCallsDetails
 */
function CreateCall(props) {
  const [validationFields, setValidationFields] = useState([]);
  const [attachments, setAttchments] = useState([]);
  const [currentDate] = useState(moment(new Date(), Defines.Format.MomentDateTime).format(Defines.Format.MomentDateTime));
  const [duplicateData, setDuplicateData] = useState(null);

  const { windowKey, openPopup, closeAllPopups, record, isDuplicate, isSat, culture } = props;
  const currentNetworkRole = (localStorage.getItem('currentNetworkRole') || '').replace(/^"|"$/g, '').trim().toLowerCase();
  const isReadOnlyRole = currentNetworkRole.includes('readonlyuser');
  
  const history = useHistory();
  const networkCode = useMemo(() => {
    const value = localStorage.getItem('networkCode');
    if (!value) {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }, []);

  const networkValidation = useMemo(() => {
    if (!networkCode) {
      return null;
    }
    const userDataValue = localStorage.getItem('userData');
    if (!userDataValue) {
      return null;
    }
    try {
      const userData = JSON.parse(userDataValue);
      return userData?.networks?.find(n => n?.code === networkCode) || null;
    } catch {
      return null;
    }
  }, [networkCode]);

  const useDetailResult = useDetail({
    data: { ID: record?.ID || null },
    updateUrl: ApiUrl.CreateServiceCall,
    windowKey,
    dataLoadUrl: ApiUrl.ServiceCallLoad,
    nameField: 'code',
    backPage: AppPages.ServiceCalls,
    listUpdateEvent,
    validationFields,
    changingValidation: true,
    onLoadData: (response, setDataItem) => {
      setDataItem({ ...response, wish_date_from: currentDate });
      return true;
    },
    // detailUrl: Project.getPageUrl(AppPages.ServiceCallsDetails)
  });

  const { dataItem, setDataItem, updateData, onChangeData, validation, detailRef } = useDetailResult;

  const mapInstallerData = (record) => ({
    installer_name: record?.installer_name || '',
    installer_company: record?.installer_company || '',
    installer_zip_code: record?.installer_zip_code || '',
    installer_city: record?.installer_city || '',
    installer_street: record?.installer_street || '',
    installer_phone: record?.installer_phone || '',
    installer_email: record?.installer_email || '',
    installation_date: record?.installation_date || ''
  });

  const loadInstallerBySerialNumber = useCallback((serialNumber) => {
    const normalizedSerialNumber = serialNumber?.trim();
    if (!normalizedSerialNumber) {
      return;
    }

    if (process.env.REACT_APP_INSTALLER_ENABLED !== 'true') {
      return;
    }

    Ajax.get({
      url: ApiUrl.ServiceCallLoadLatestBySerialNumber,
      data: { internal_serial_number: normalizedSerialNumber, reseau_code: networkCode },
      success: function (response) {
        if (!response) {
          return;
        }

        let dataToMap = response;
        if (response?.Data) {
          dataToMap = Array.isArray(response.Data) ? response.Data[0] : response.Data;
        }

        const installerData = mapInstallerData(dataToMap);
        const hasInstallerData = Object.values(installerData).some(Boolean);

        if (!hasInstallerData) {
          return;
        }

        setDataItem(prev => ({
          ...prev,
          ...installerData
        }));
      }
    });
  }, [networkCode, setDataItem]);

  const installerNameRequired = networkValidation?.installer_name_required;
  const installerCompanyRequired = networkValidation?.installer_company_required;
  const installerZipCodeRequired = networkValidation?.installer_zip_code_required;
  const installerCityRequired = networkValidation?.installer_city_required;
  const installerStreetRequired = networkValidation?.installer_street_required;
  const installerPhoneRequired = networkValidation?.installer_phone_required;
  const installerEmailRequired = networkValidation?.installer_email_required;
  const installationDateRequired = networkValidation?.installation_date_required;

  useEffect(() => {
    let fields = [];

    if (process.env.REACT_APP_INSTALLER_ENABLED === 'true') {
      if (installerNameRequired) {
        fields.push('installer_name');
      }
      if (installerCompanyRequired) {
        fields.push('installer_company');
      }
      if (installerZipCodeRequired) {
        fields.push('installer_zip_code');
      }
      if (installerCityRequired) {
        fields.push('installer_city');
      }
      if (installerStreetRequired) {
        fields.push('installer_street');
      }
      if (installerPhoneRequired) {
        fields.push('installer_phone');
      }
      if (installerEmailRequired) {
        fields.push('installer_email');
      }
      if (installationDateRequired) {
        fields.push('installation_date');
      }
    }

    setValidationFields(fields);
  }, [
    installerNameRequired,
    installerCompanyRequired,
    installerZipCodeRequired,
    installerCityRequired,
    installerStreetRequired,
    installerPhoneRequired,
    installerEmailRequired,
    installationDateRequired,
  ]);

  const _serial_number = props?.location?.state?._data?.internal_serial_number;
  const codeProduct = dataItem?.code_product;
  const normalizedSerialNumber = dataItem?.internal_serial_number?.trim();

  useEffect(() => {
    if (!codeProduct || !normalizedSerialNumber) {
      return;
    }

    const timeoutId = setTimeout(() => {
      loadInstallerBySerialNumber(normalizedSerialNumber);
    }, 400);

    return () => clearTimeout(timeoutId);
  }, [codeProduct, normalizedSerialNumber, loadInstallerBySerialNumber]);
  
useEffect(() => {
  if (dataItem) {
    const _data = {
      service_call_id: dataItem.ID ? dataItem.ID : "",
      City: dataItem.ville,
      CodeCom: "", //dataItem.code_product,
      Country: dataItem.pays,
      // EndDate: dataItem.warranty_end_date,
      // ExtensionDate: dataItem.warranty_extension_date,
      InsId: dataItem.ins_id,
      InternalSN: dataItem.internal_serial_number,
      ItemCode: dataItem.item_code,
      ItemName: dataItem.item_name,
      OwnerCode: '', // dataItem.code_client, // customer_code
      OwnerEmail: dataItem.email,
      OwnerName: dataItem.customer_name,
      OwnerPhone: dataItem.phone,
      OwnerPhone2: dataItem.phone2,
      // StartDate: dataItem.warranty_start_date,
      Street: dataItem.adresse, // street + street number 
      StreetNo: dataItem.street_number,
      Block: dataItem.door_number,
      Zip: dataItem.code_postal,
      Key: dataItem.ins_id,
      // IsProduct: true
    }

    setDuplicateData(() => _data);
  }
}, [dataItem])

  useEffect(() => {
    if(_serial_number) {
      setDataItem({ ...dataItem, internal_serial_number: _serial_number });
    }
    if (isDuplicate && dataItem) {
      setDataItem({ ...dataItem, product_code: dataItem.code_product });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDataItem, dataItem?.ID]);

  useEffect(() => {
    if (dataItem?.type && dataItem?.family && dataItem?.reason) {
      const { type, family, reason } = dataItem;
      setDataItem(prev => ({
        ...prev,
        diagnosis: `${type}_${family}_${reason}`,
      }));
    }
  }, [dataItem?.type, dataItem?.family, dataItem?.reason]); // eslint-disable-line react-hooks/exhaustive-deps

   const onCodeChanged = useCallback((field, value) => {
    setDataItem(prev => {
      const newItem = { ...prev };
      switch (field) {
        case 'type':
          newItem.type = value ?? '';
          newItem.family = '';
          newItem.reason = '';
          newItem.diagnosis = '';
          break;
        case 'family':
          newItem.family = value ?? '';
          newItem.reason = '';
          newItem.diagnosis = '';
          break;
        case 'reason':
          newItem.reason = value ?? '';
          newItem.diagnosis = '';
          break;
        default:
          break;
      }
      return newItem;
    });
    }, [dataItem, setDataItem]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateSuccessCallback = (response) => {
    if (detailRef.current) {
      // debugger;
      if (!isDuplicate && (isSat || response.societe_uuid)) {
        updateCallback(response);
      } else {
        openPopup({
          type: PopupTypes.Confirm,
          title: <T>text.assign_subcontractor</T>,
          text: <T> message.assign_manually</T>,
          description: <T> message.assign_manually_description</T>,
          buttonYesText: <T>text.assign_manually</T>,
          buttonNoText: <T>text.assign_with_algorithm</T>,
          ...(!response?.hide_assign_to_previous_button && {
            buttons: [{
              text: <T>text.assign_to_the_previous_SAT</T>, callback: (onClose) => {
                autoAssign(response, 'assignToPreviousSat');
                onClose();
              }
            }]
          }),
          yesCallback: function () { openPicker(response); },
          noCallback: function () { autoAssign(response, 'assign'); }
        });
      }

    }

  };

  const autoAssign = (response, updateType) => {
    showLoader('assign_auto');
    Ajax.post({
      url: ApiUrl.ServiceCallUpdate,
      data: { id: response.ID, update_type: updateType },
      success: function (result) {
        updateCallback(result);
        hideLoader('assign_auto');

      }
    });
  };

  const updateCallback = (data) => {
    closeAllPopups();
    history.push(Project.getPageUrl(AppPages.ServiceCallsDetails, data.ID));
    globalThis.location.reload();
  };

  const openPicker = record => {
    openPopup({
      windowKey,
      title: <T>text.assign_subcontractor</T>,
      type: PopupTypes.SocietePicker,
      bodyProps: {
        ...{ ID: record.ID, data: record, updateCallback }
        // updateData: (record) => { updateData(updateSuccessCallback, null, { overrideData: { ID: dataItem.ID, societe_uuid: record.uuid } }) }
      },
      // className: PopupClasses.Large,
      fullScreen: false
    });
  };

  const internal_serial_number = dataItem?.internal_serial_number;
  const openEquipmentCards = useCallback(() => {
    openPopup({
      windowKey: 'wndEquipmentCard',
      title: <T>text.pick_equipment_card</T>,
      type: PopupTypes.EquipmentCardPicker,
      // className: PopupClasses.Large,
      fullScreen: false,
      bodyProps: { internal_serial_number, setDataItem, duplicateData: duplicateData/*, loadInstallerBySerialNumber */ },
    });
  }, [internal_serial_number, setDataItem, openPopup, duplicateData/*, loadInstallerBySerialNumber */]);

  let diagnosis = dataItem?.diagnosis;

    if (diagnosis) {
        diagnosis = diagnosis.split('_').map(part => part.trim()).slice(0, 3).join('\n');
    }

  let serviceCallData = dataItem && <>
    <div className="form_container">
      <view auto_height=''
      >
        <div className='section_group'>
          <div className='sections'>
            <InputCont
              label='text.call_type'
              inputProps={{
                type: 'select',
                valuelist: 'call_type',
                name: 'call_type_id',
                value: dataItem.call_type_id,
                disableCach: true,
                placeholder: "",
                onChange: (e) => onChangeData({ target: { name: 'call_type_id', value: e } })
              }}
            />
          </div>
          <div className='sections'>
            <InputCont
              label='text.start_date'
              inputProps={{
                validation,
                allowClear: false,
                type: 'datetime',
                name: 'wish_date_from',
                dataItem: dataItem,
                setDataItem,
                dataField: 'wish_date_from'
              }}
            />
          </div>
          <div className='sections '>
            <InputCont
              label='text.serial_number'
              inputProps={{
                name: 'internal_serial_number',
                value: dataItem.internal_serial_number,
                maxLength: 250,
                onChange: onChangeData,
                validation
              }}
              icon={<div effect="material" className="button mini " disabled={!dataItem.internal_serial_number} onClick={openEquipmentCards}
              ><icon >search</icon></div>}

            />
          </div>
          <div className='sections '>
            <InputCont
              label='text.product_code'
              inputProps={{
                name: 'product_code',
                value: dataItem.product_code,
                maxLength: 250,
                onChange: onChangeData,
                validation,
                disabled: true
              }}
            />
          </div>
        </div>
        <div className='section_group'>
          <div className='sections'>
            <InputCont
              label='text.problem_type'
              inputProps={{
                type: 'select',
                valuelist: '_problem_type',
                name: 'problem_type_id',
                value: dataItem.problem_type_id,
                parentValue: dataItem.call_type_id,
                disabled: dataItem.call_type_id === "",
                disableCach: true,
                placeholder: "",
                onChange: (e) => onChangeData({ target: { name: 'problem_type_id', value: e } })
              }}
            />
          </div>
          <div className='sections'>
            <InputCont
              label='text.priority'
              inputProps={{
                type: 'select',
                valuelist: 'priority',
                name: 'priority',
                value: dataItem.priority,
                additionalData: culture,
                placeholder: "",
                onChange: (e) => onChangeData({ target: { name: 'priority', value: e } })
              }}
            />
          </div>
          <div className='="sections'>
            <label className="checkbox" classic="" style={{margin: '0 20px', top: "50%", transform: "translateY(-50%)"}}
            >
              <input
                type="checkbox"
                name="fictive_serial_number"
                checked={dataItem.fictive_serial_number}
                onChange={onChangeData}
                // onChange={(event) => setRemember(event.target.checked)}
              /><box><check></check></box><text><T>text.fictive_serial_number</T></text>
            </label>
          </div>
        </div>
        <div className='section_group'>
          <div className='sections wide'>
            <InputCont
              label='text.subject'
              inputProps={{
                name: 'subject',
                value: dataItem.subject,
                placeholder: "",
                maxLength: 250,
                onChange: onChangeData
              }}
            />
            <InputCont
              label='text.description'
              inputProps={{
                type: 'textarea',
                name: 'description',
                value: dataItem.description,
                maxLength: 2000,
                placeholder: "",
                onChange: onChangeData
              }}
            />
          </div>
          <div className='sections '>
            <InputCont
              label='text.type'
              inputProps={{
                // disabled,
                name: 'type',
                type: 'select',
                valuelist: '_defect_codes',
                additionalData: '1',
                // parentValue: props?.dataItem?.business_unit || '',
                disableCach: true,
                value: dataItem.type,
                onChange: e => onCodeChanged('type', e),
                allowClear: true,
              }}
            />

            <InputCont
              label='text.family'
              inputProps={{
                name: 'family',
                type: 'select',
                valuelist: '_defect_codes',
                additionalData: '2',
                // // parentValue: dataItem.defect_code1,
                parentValue: dataItem.type.split(" - ")[0],
                disableCach: true,
                disabled: !dataItem.type,
                value: dataItem.family,
                onChange: e => onCodeChanged('family', e),
                allowClear: true,
                // validation: validation 
              }}
            />

          </div>
          <div className='sections'>
            <InputCont
              label='text.reason'
              inputProps={{
                name: 'reason',
                type: 'select',
                valuelist: '_defect_codes',
                additionalData: '3',
                // // parentValue: dataItem.defect_code2,
                parentValue: dataItem.family.split(" - ")[0],
                disableCach: true,
                disabled: !dataItem.family,
                value: dataItem.reason,
                onChange: e => onCodeChanged('reason', e),
                allowClear: true,
                // validation: validation
              }}
            />

            <InputCont
              label='text.diagnosis'
              inputProps={{
                name: 'diagnosis',
                type: 'textarea',
                disabled: true,
                value: diagnosis,
                // onChange: e => onCodeChanged('diagnosis', e),
                allowClear: true,
              }}
            />
          </div>
        </div>
        {process.env.REACT_APP_INSTALLER_ENABLED === 'true' &&  <div className='section_group'>
          <div className='sections'>
              <InputCont
                  label='text.installer_name_required'
                  inputProps={{ name: 'installer_name', validation, value: dataItem.installer_name, placeholder: "", onChange: onChangeData }}
              />
              <InputCont
                  label='text.installer_company_required'
                  inputProps={{ name: 'installer_company', validation, value: dataItem.installer_company, placeholder: "", onChange: onChangeData }}
              />
          </div>
          <div className='sections'>
              <InputCont
                  label='text.installer_zip_code_required'
                  inputProps={{ name: 'installer_zip_code', validation, value: dataItem.installer_zip_code, placeholder: "", onChange: onChangeData }}
              />
              <InputCont
                  label='text.installer_city_required'
                  inputProps={{ name: 'installer_city', validation, value: dataItem.installer_city, placeholder: "", onChange: onChangeData }}
              />
          </div>
          <div className='sections'>
              <InputCont
                  label='text.installer_street_required'
                  inputProps={{ name: 'installer_street', validation, value: dataItem.installer_street, placeholder: "", onChange: onChangeData }}
              />
              <InputCont
                  label='text.installer_phone_required'
                  inputProps={{ name: 'installer_phone', validation, value: dataItem.installer_phone, placeholder: "", onChange: onChangeData }}
              />
          </div>
          <div className='sections'>
              <InputCont
                label='text.installer_email_required'
                inputProps={{
                    validation,
                    name: 'installer_email',
                    value: dataItem.installer_email,
                    placeholder: "",
                    onChange: onChangeData
                }}
            />
            <InputCont
              label='text.installation_date_required'
              inputProps={{
                  // disabled: true,
                  validation,
                  name: 'installation_date',
                  type: 'date',
                  dataItem,
                  dataField: 'installation_date',
                  format: Defines.Format.MomentDate,
                  placeholder: "",
                  setDataItem
              }}
            />
          </div>
        </div>}
        <div className='section_group' style={{ padding: '20px' }}>
          <Attachments dataSource={attachments} setDataSource={setAttchments} />
        </div>
      </view>
    </div>
    <toolbar>
      <wrap>
        <action right=''
        >
          <div 
            onClick={(e) => updateData(updateSuccessCallback, null, { additionalData: { attachments } })} 
            className='button'
            disabled={isReadOnlyRole}
          ><icon>save</icon><T>text.save</T></div>
        </action>
      </wrap>
    </toolbar>
  </>;

  return (<>
    {isDuplicate ?
      serviceCallData
      : <DetailView
        backUrl={Project.getPageUrl(AppPages.ServiceCalls)}
        title={<T>text.create_new_call</T>}
        sare>
        {serviceCallData}
      </DetailView>
    }
  </>);
}

CreateCall.propTypes = {
    windowKey: PropTypes.string.isRequired,
    openPopup: PropTypes.func.isRequired,
    closeAllPopups: PropTypes.func.isRequired,
    record: PropTypes.object,
    isDuplicate: PropTypes.bool.isRequired,
    isSat: PropTypes.bool.isRequired,
    culture: PropTypes.string.isRequired,
    location: PropTypes.object
};

export default connect(state => ({
  isDispatcher: state.role === UserRoles.DISPATCHER,
  isSat: state.role === UserRoles.USER,
  culture: state.culture
}), dispatch => ({ dispatch, openPopup: (props) => dispatch(openPopup(props)), closeAllPopups: () => dispatch(closeAllPopups()) }))(CreateCall);